module.exports = __webpack_public_path__ + "static/media/banner_sendero_contigo_mobil.0d695bc4.jpg";